<template>
  <div class="dialog-collection-widget-edit relative">
    <remove-btn />
  </div>
</template>

<script>
import RemoveBtn from '~/components/common/RemoveBtn.vue'

export default {
  components: { RemoveBtn },
  data() {
    return {}
  }
}
</script>

<style lang="less">

</style>
